import { Component } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthServiceService } from '../services/auth-service.service';
import { CommonModule } from '@angular/common';
import { RouterModule,Router } from '@angular/router';
import { showCustomeAlert } from '../services/Alert/alert.service';

@Component({
  selector: 'app-login-register',
  imports: [CommonModule,FormsModule,ReactiveFormsModule,RouterModule],
  templateUrl: './login-register.component.html',
  styleUrl: './login-register.component.scss'
})
export class LoginRegisterComponent {
  isSignInMode: boolean = true;
  constructor(private _authService:AuthServiceService,private _route : Router){}

  LoginForm = new FormGroup({
    userName: new FormControl("", [
      Validators.required,
    ]),

    password: new FormControl("", [
      Validators.required,
    ]),
  });

  registerForm = new FormGroup({
    firstName: new FormControl("", [Validators.required]),
    lastName: new FormControl("", [Validators.required]),
    userName: new FormControl("", [Validators.required]),
    email: new FormControl("", [Validators.required, Validators.email]),
    password: new FormControl("", [Validators.required, Validators.minLength(6)]),
    repeatPassword: new FormControl ("", Validators.required)
  });

  onLoginSubmit() {
    if (this.LoginForm.valid) {
      const {userName,password} = this.LoginForm.value;
      
      this._authService.login(userName,password).subscribe(response => {
        sessionStorage.setItem("user",JSON.stringify(response.result))
        this._route.navigate([''])
      }, error => {
        this.LoginForm.reset()
        showCustomeAlert("error","Username or Password are incorrect","Login Failed")
      });
    }else{
      showCustomeAlert("warning","Fill the  empty field first.","Empty Field")
    }
  }

  // Handle registration form submission
  onRegisterSubmit() {
    if (this.registerForm.valid && this.registerForm.value.password === this.registerForm.value.repeatPassword) {
      const {firstName,lastName,password,email,userName} = this.registerForm.value;
      this._authService.register({firstName,lastName,userName,email,password}).subscribe(response => {
        this.registerForm.reset();
        this._route.navigate(['user'])
      }, error => {
        showCustomeAlert("error","Something Wrong happend","Registration Failed")
      });
    } else {
      showCustomeAlert("warning","Password should match and all fields are required..","Alert")
    }
  }

  toggleSignInMode(): void {
    this.isSignInMode = !this.isSignInMode;
  }
}
